// Generated by ts-to-zod
import {z} from "zod";

export const mantineSizeTokenSchema = z.union([
	z.literal("xs"),
	z.literal("sm"),
	z.literal("md"),
	z.literal("lg"),
	z.literal("xl"),
	z.string(),
]);

export const mantineSpacingSchema = z.union([
	z.literal("xs"),
	z.literal("sm"),
	z.literal("md"),
	z.literal("lg"),
	z.literal("xl"),
	z.string(),
	z.number(),
]);
